import { app } from '../../../bootstrap/core';
import passwordRequirementsCheck from './passwordRequirementsCheck.component';

app.component('passwordRequirementsCheck', passwordRequirementsCheck);
